/**
 * UserProtectedRoute Component
 *
 * Convenience component for user-only routes.
 * Redirects to "/" if user is not a regular user (mobile OTP login).
 */

import ProtectedRoute from "./ProtectedRoute";

const UserProtectedRoute: React.FC = () => {
  return <ProtectedRoute requiredRole="user" redirectTo="/" />;
};

export default UserProtectedRoute;
